import Image from 'next/image';
import { useRef, useState } from 'react';
import { LANGUAGE_ENUMS } from '../../constants/staticPageConstants';
import { ButtonVariants } from '../Atoms/Button';
import { DemoModal } from '../Atoms/DemoModal';
import { MarktechModal } from '../Atoms/Modal';
import { CloseIcon } from '../Icons';
import { useOnClickOutside } from '../hooks';
import { GeneralDropdown, GeneralMobileDropdown } from './DropdownOptions';
import {
  DropdownComponent,
  TDropdownElement,
  TDropdownList,
} from './DynamicHeader/Dropdown/DropdownComponent';
import { THeaderLabels } from './DynamicHeader/Dropdown/DropdownData';
import { CommonData } from './DynamicHeader/Dropdown/DropdownDataFrCommon';
import { HamburgerMenu } from './HamburgerMenu';
import { LoginButton } from './LoginButton';
import { getLogoLink } from './utils';

interface DotComMobileNavbarI {
  direction: 'rtl' | 'ltr';
  domain: number;
  language: LANGUAGE_ENUMS;
  LangSwitchLink?: TDropdownList;
  header_labels: THeaderLabels;
  mobileDropdownProps: {
    dropdownLabel: string;
    dropdownList: CommonData[] | undefined;
  }[];
  contact_us_page: string | undefined;
}

export const DotComMobileNavbar = ({
  direction,
  domain,
  language = LANGUAGE_ENUMS.English,
  header_labels,
  LangSwitchLink,
  mobileDropdownProps,
  contact_us_page,
}: DotComMobileNavbarI): JSX.Element => {
  const [active, setActive] = useState(false);
  const modalRef = useRef(null);
  const [displayPopup, demoPopup] = useState(false);
  useOnClickOutside(modalRef, () => {
    demoPopup(false);
  });
  const handleClick = () => {
    setActive((prevState) => !prevState);
  };
  return (
    <>
      <div
        className="bg-white p-3 w-full fixed top-0 z-20 font-medium sm:px-0"
        style={{ direction: direction }}
        data-testid="Header"
      >
        <nav className="flex items-center z-20 gap-2 flex-wrap  md:w-full sm:w-full font-medium wg-container">
          <a
            href={getLogoLink(domain, language)}
            className="inline-flex items-center p-0 -ml-1.5"
          >
            <Image
              src="https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/d9f36ac3-77a9-40c6-94fc-20c2e3855457.svg"
              alt="Cleartax"
              width={120}
              height={22}
            />
          </a>

          <DropdownComponent
            dropdownLabel={header_labels.language}
            dropdownList={LangSwitchLink as TDropdownList}
            Dropdown={
              GeneralMobileDropdown as React.ElementType<TDropdownElement>
            }
            language={language}
            domain="sa"
            classes="xl:hidden lg:hidden wd:hidden sm:p-0 sm:pr-2 relative"
          />

          <div
            className={
              'inline-flex rounded gap-2 md:hidden lg:hidden xl:hidden text-grey-850 ' +
              (language === LANGUAGE_ENUMS.English ? ' ml-auto' : 'mr-auto')
            }
          >
            <HamburgerMenu handleMenuClick={handleClick} isOpen={active} />
          </div>

          <div
            className={`hidden ${active ? 'sm:block' : ''}  w-full bg-white`}
          >
            <div className="w-full">
              {mobileDropdownProps.map((dropdownProps) => (
                <div key={dropdownProps.dropdownLabel}>
                  <DropdownComponent
                    {...dropdownProps}
                    Dropdown={
                      GeneralDropdown as React.ElementType<TDropdownElement>
                    }
                    domain="sa"
                    language={language}
                    classes="sm:p-0 sm:w-full"
                  />
                </div>
              ))}

              <button
                type="button"
                className="font-medium flex w-auto py-2 rounded text-font-500 whitespace-nowrap mr-3"
                aria-expanded="true"
                aria-haspopup="true"
              >
                <a
                  href={contact_us_page}
                  rel="noreferrer"
                  className="sm:text-s-12 text-font-500"
                >
                  {header_labels.contact_us}
                </a>
              </button>
              <div className="flex justify-center sm:flex-row">
                <div className="sm:px-1 sm:py-2 sm:w-full ">
                  <LoginButton
                    buttonColor={ButtonVariants.greyfilled}
                    language={language}
                    link="https://accounts.cleartax.com/v2?product=einvoice&return_path=L21pZGRsZS1lYXN0L2tzYS9laW52b2ljaW5nLw=="
                  />
                </div>
                <div
                  className="sm:px-1 sm:py-2 whitespace-nowrap sm:w-1/2"
                  onClick={() => demoPopup(true)}
                >
                  <span className="button button-bluefilled font-bold inline-flex items-center lg:w-auto rounded-lg text-base w-full whitespace-nowrap">
                    {header_labels.demo}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
      <div className="h-16"></div>
      <MarktechModal
        open={displayPopup}
        onClose={() => console.log('side bar')}
        classNames={{
          modal: 'w-full mobile-search-box rounded-2xl',
        }}
        closeIcon={<CloseIcon />}
        center
      >
        <DemoModal
          modalRef={modalRef}
          demoPopup={demoPopup}
          language={language}
          domain={domain}
        />
      </MarktechModal>
    </>
  );
};
